import { EnumConstantInterface, EnumOption } from '../models/general.models';

export enum AccountTypeEnum {
    Investor,
    Issuer,
}

export enum EntityEnum {
    Issuer,
    IndividualInvestor,
    NonIndividualInvestor,
    Individual,
}

export enum AccountEntityTypeEnum {
    Individual,
    NonIndividual,
}

export enum RoleEnum {
    SuperAdmin = 1,
    VerifiedCorporateInvestor = 2,
    UnverifiedCorporateInvestor = 3,
    RestrictedCorporateInvestor = 4,
    VerifiedIssuer = 5,
    UnverifiedIssuer = 6,
    RestrictedIssuer = 7,
    AllMaker = 8,
    AllChecker = 9,
    AllViewOnly = 10,
    VerifiedIndividualInvestor = 11,
    UnverifiedIndividualInvestor = 12,
    RestrictedIndividualInvestor = 13,
}

export enum ProfileStatusEnum {
    Draft,
    PendingReview,
    Approved,
    Rejected,
}

export const PROFILE_STATUS_OPTION: EnumConstantInterface = {
    [ProfileStatusEnum.Draft]: {
        cssClass: 'blue',
        label: 'Draft',
    },
    [ProfileStatusEnum.PendingReview]: {
        cssClass: 'orange',
        label: 'Pending Review',
    },
    [ProfileStatusEnum.Approved]: {
        cssClass: 'green',
        label: 'Approved',
    },
    [ProfileStatusEnum.Rejected]: {
        cssClass: 'red',
        label: 'Rejected',
    },
};

export function getProfileStatusOption(status: ProfileStatusEnum): EnumOption {
    const foundOption = PROFILE_STATUS_OPTION[status];

    if (!foundOption) {
        return new EnumOption();
    }

    return foundOption;
}

export enum CurrentRegistrationStep {
    PendingProfile,
    PendingSecurityQuestion,
    PendingPayment,
}

export enum AccountVerificationStatusEnum {
    NotRegistered = 0,
    Restricted = 1,
    Unverified = 2,
    Verified = 3,
}

export const ACCOUNT_VERIFICATION_STATUS_OPTION: EnumConstantInterface = {
    [AccountVerificationStatusEnum.NotRegistered]: { cssClass: 'red', label: '' },
    [AccountVerificationStatusEnum.Restricted]: { cssClass: 'red', label: '' },
    [AccountVerificationStatusEnum.Unverified]: { cssClass: 'orange', label: '' },
    [AccountVerificationStatusEnum.Verified]: { cssClass: 'green', label: '' },
};

export function getAccountVerificationStatusOption(status: AccountVerificationStatusEnum): EnumOption {
    const foundedEnum = ACCOUNT_VERIFICATION_STATUS_OPTION[status];

    if (!foundedEnum) {
        return new EnumOption();
    }

    return foundedEnum;
}
